angular
  .module('cfn')
  .controller('bookingListController', bookingListController);

bookingListController.$inject = [
  '$scope',
  '$log',
  '$rootScope',
  '$location',
  '$sce',
  '$dialog',
  '$http',
  '$route',
  '$q',
  'i18nFilter',
  'BookingOperations',
  'bookingRenderService',
  'bookingService',
  'LocalStorageService',
  'timeZoneHackService',
  'bookingImportWizardService'
];
function bookingListController(
  $scope,
  $log,
  $rootScope,
  $location,
  $sce,
  $dialog,
  $http,
  $route,
  $q,
  i18nFilter,
  BookingOperations,
  bookingRenderService,
  bookingService,
  LocalStorageService,
  timeZoneHackService,
  bookingImportWizardService
) {
  //state stores the filter state and will be completely loaded after the grid is initialized.
  var state = {
    _gridController: null, //reference to the grid controller
    _localStorageName: null, //name under which this state will be stored

    current: null,
    defaultState: function() {
      return {
        gridFilter: {
          bookingYear: String(
            bookingService.harvestHelper.harvestYearFromToday()
          )
        },
        gridSorting: null
      };
    },
    /**
     * returns if this filter was initialized.
     */
    initializeFilter: function(name, requestDataFn) {
      var storedState = JSON.parse(LocalStorageService.get(name));
      state._localStorageName = name;
      state.requestDataFn = requestDataFn;
      state.current = storedState || state.defaultState();
    },
    loadGridState: function(gridController) {
      var firstTime = !!state._gridController;
      if (gridController) state._gridController = gridController;
      if (!state._gridController) return;

      var filters = state.getFilters();
      var showingRealBookings = filters && filters.state === 'BOOKED';
      //load grid filters
      _.each(state.current.gridFilter, function(val, key) {
        if (showingRealBookings || key !== 'bookingYear')
          state._gridController.setFilter(key, val, true);
      });
      //load grid sorting
      if (state.current.gridSorting) {
        state._gridController.setSortedColumns(state.current.gridSorting);
      }

      if (firstTime) state.save();
    },
    getFilters: function() {
      return state._gridController ? state._gridController.getFilters() : {};
    },
    save: function() {
      var wasInitialized = !!state._localStorageName;
      if (wasInitialized && state._gridController) {
        var originalFilter = angular.copy(state.current.gridFilter);
        var filters = state.getFilters();
        var currentState = {
          gridFilter: _.object(
            _.filter(
              _.pairs(filters),
              //do not store the state value
              function(entry) {
                return entry[0] != 'state';
              }
            )
          ),
          gridSorting: state._gridController.getSortedColumns()
        };
        if (filters.state !== 'BOOKED') {
          //retain the loaded harvestYear since other tabs don't use them
          currentState.gridFilter.bookingYear =
            state.current.gridFilter.bookingYear;
        }
        //store in memory and in local storage
        state.current.gridFilter = currentState.gridFilter;
        LocalStorageService.set(
          state._localStorageName,
          JSON.stringify(currentState)
        );
        if (state.requestDataFn) {
          var specificOrDistinctHarvestYear =
            originalFilter.bookingYear &&
            currentState.gridFilter.bookingYear != originalFilter.bookingYear;
          var shouldSendRequest = specificOrDistinctHarvestYear;
          if (shouldSendRequest) state.requestDataFn();
        }
      }
    },
    reset: function(shouldSave) {
      state.current = state.defaultState();
      if (state._gridController) {
        state._gridController.resetFilters();
        state._gridController.resetSortedColumns();
      }
      if (shouldSave) {
        LocalStorageService.set(state._localStorageName, null);
      }
    }
  };
  var controller = ($scope.controller = this),
    isUpdatingList = false,
    currentStatus = getCookie('booking.selectedState') || 2,
    init = function() {
      controller.gridBooking = null;
      controller.selectedListItem = null;
      controller.data = [];
      controller.cropYears = [];

      // Delegate Rendering to shared Service
      controller.activityIconRenderer =
        bookingRenderService.activityIconRenderer;
      controller.assetRenderer = bookingRenderService.assetRenderer;
      controller.supplyRenderer = bookingRenderService.supplyRenderer;
      controller.personRenderer = bookingRenderService.personRenderer;
      controller.machineRenderer = bookingRenderService.machineRenderer;

      //this is turned off as it must be propertly implemented in the Presentation Layer
      //TODO: return filter options (all available Harvest Year, etc)
      //state.initializeFilter("booking.filter", controller.updateList);
      state.initializeFilter('booking.filter');

      ang.callAfter(function() {
        controller.recalcSize();
      }, $scope);
    };

  // --- Controller function declarations ---

  // status
  controller.statusPossibilities = [
    {
      title: i18nFilter('fe.booking.type.INPLANNING', 'Planung'),
      type: 'INPLANNING'
    },
    {
      title: i18nFilter('fe.booking.type.PRELIMINARY', 'Vorläufig'),
      type: 'PRELIMINARY'
    },
    {
      title: i18nFilter('fe.booking.type.BOOKED', 'Gebucht'),
      type: 'BOOKED'
    }
  ];

  controller.cellClick = function(columnName, rowData, rowIndex, column) {
    controller.selectedListItem = rowData;
    if (controller.selectedListItem)
      $location.path('/booking/field/' + controller.selectedListItem.id);
  };

  controller.openExportDialog = function() {
    bookingImportWizardService.openExportDialog().then(exitResult => {
      if (exitResult && exitResult.action === 'success') {
        if ($scope.onfinish) $scope.onfinish();
      }
    });
  };

  // Tabwechsel
  controller.statusChange = function(status) {
    //old status item
    if (controller.currentStatus) controller.currentStatus.active = false;

    //new status item
    controller.currentStatus = $scope.currentStatus = status;
    controller.currentStatus.active = true;

    setCookie(
      'booking.selectedState',
      controller.statusPossibilities.indexOf(status)
    );

    if (controller.gridBooking) {
      controller.gridBooking.setFilter('state', status.type, true);
      // Clear filter for views that don't have those columns
      if (controller.currentStatus.type !== 'BOOKED') {
        controller.gridBooking.setFilter('bookingYear', undefined);
      }
    }

    controller.clearSelection();
    state.loadGridState(); //required cause not all tabs have the same filters
    controller.checkFilters();
  };

  // calculate tab size
  controller.recalcSize = function() {
    controller.tabHeight = $('.nav.nav-tabs:first').height();
  };

  controller.updateListFilter = function() {
    var result = [],
      i;
    controller.dataCount = {};

    controller.data.forEach(function(dat) {
      // counter for different states
      if (!controller.dataCount[dat.state]) {
        controller.dataCount[dat.state] = 0;
      }
      controller.dataCount[dat.state] += 1;
      dat.date = timeZoneHackService.toClientTimezone(dat.date).getTime();
      result.push(dat);
    });
    for (i = 0; i < controller.statusPossibilities.length; i++) {
      var status = controller.statusPossibilities[i];
      if (controller.dataCount[status.type])
        status.count = ' (' + controller.dataCount[status.type] + ')';
      else status.count = ' (0)';
    }
    controller.listData = result;

    ang.callAfter(function() {
      controller.updateSelection();
      controller.checkFilters();
    }, $scope);
  };
  //this is a work around to assure the selected filter exists, if not it will be removed.
  controller.checkFilters = function() {
    var filters = controller.gridBooking.getFilters();
    var year = filters['bookingYear'];
    var years = controller.gridBooking.getFilterOptions('bookingYear');

    if (year && !_.contains(years, year)) {
      //selection is not valid... remove
      delete filters['bookingYear'];
      //years.push(year); //this would add the option instead, but the user might not see this happening..
    }
  };
  //controller.updateListFilter(); // initial list setup
  controller.updateSelection = function() {
    // we need to call the sync after changes of the grid
    var gridScope = $('#dataGrid').isolateScope();
    if (
      gridScope &&
      gridScope.controller &&
      $scope.details &&
      $scope.details.id
    ) {
      controller.selectedListItem = $scope.details;
    }
  };

  controller.clearSelection = function() {
    if (controller.gridBooking) controller.gridBooking.clearSelection();
    controller.selectedListItem = null;
  };

  controller.updateList = function() {
    if (isUpdatingList)
      // not allowed to update multiple times
      return;
    app.showLoader();
    isUpdatingList = true;
    //turning this off until we are able to fill this with proper data and not with the data already acquired
    /*var filters = _.object(_.filter(_.pairs(state.getFilters()),
            //do not store the state value
            function(entry) {
                return entry[1] != null && entry[0] === 'bookingYear';
            }));*/
    var filters = {};

    var operations = BookingOperations.query(
      angular.copy(filters, {
        harvestYear: controller.selectedYear,
        section: $scope.details.bookingSection
      }),
      function() {
        isUpdatingList = false;
        controller.data = operations;

        controller.updateListFilter();
        app.hideLoader();
      }
    );
  };

  controller.gridInit = function(grid, scope) {
    controller.gridBooking = grid;
    controller.statusChange(controller.statusPossibilities[currentStatus]);
    state.loadGridState(grid);
    controller.updateList();
  };

  controller.onFilterBlur = function(col, value) {
    state.save();
  };

  // --- Scope function declarations ---
  $scope.details = {
    bookingSection: 'FIELD'
  };

  $scope.$on('windowResize', function() {
    ang.callAfter(function() {
      controller.recalcSize();
    }, $scope);
  });

  $scope.$on('#BookingAdded', function(event, args) {
    // Some other module added a booking, so refresh the list
    controller.updateList();
  });

  var callOperationService = function(operationRow, action, method) {
    var deferred = $q.defer();
    // Default
    var params = {
      url: '/365FarmNet/rest/booking/operations/' + operationRow.id,
      method: 'POST'
    };
    if (action) {
      params.url += '/' + action;
    }
    if (method) {
      params.method = method;
    }
    app.showLoader();
    $http(params).then(function(response) {
      var result = response.data;
      if (result.success) {
        deferred.resolve(result);
      }
      // TODO: Move to finally block?
      app.hideLoader();
      if (result.messagingContext) {
        $rootScope.handleMsgContext(result.messagingContext);
      }
    });
    return deferred.promise;
  };

  $scope['delete'] = function(item) {
    callOperationService(item, undefined, 'DELETE').then(function(result) {
      item.isProcessed = true;
      item.isDeleted = true;
    });
  };

  $scope.book = function(item) {
    // Insert questions here
    $http
      .get('/365FarmNet/rest/booking/operations/' + item.id + '/questions')
      .then(function(response) {
        var result = response.data;
        var askTilling = result.tillingResetsFruit,
          askLastHarvest = result.harvestCanBeFinished;

        bookingService
          .ask('fe.booking.request.tilling.message', askTilling)
          .then(function(continueBooking) {
            if (continueBooking === false) {
              return;
            }
            var fieldNames = _.chain(item.assets)
              .filter(function(asset) {
                return asset.type === 'Field';
              })
              .map(function(field) {
                return '"' + field.name + '"';
              })
              .value();
            var key, defaultValue;
            if (fieldNames.length > 1) {
              key = 'fe.booking.request.finish.harvesting.plural';
              defaultValue =
                'Möchten Sie die Ernte auf den Schlägen {0} mit dieser Buchung abschliessen?';
            } else {
              key = 'fe.booking.request.finish.harvesting.singular';
              defaultValue =
                'Möchten Sie die Ernte auf dem Schlag {0} mit dieser Buchung abschliessen?';
            }
            bookingService
              .ask(
                i18nFilter(key, defaultValue, fieldNames.join(', ')),
                askLastHarvest
              )
              .then(function(isLastHarvest) {
                var url = 'book';
                if (isLastHarvest !== undefined) {
                  url += '?isLastHarvest=' + isLastHarvest;
                }
                callOperationService(item, url).then(function(result) {
                  item.isProcessed = true;
                  item.isBooked = true;

                  // Neues Element im aktiven Filter?
                  if (result.object.harvestYear === controller.selectedYear) {
                    controller.data.push(result.updatedElement);
                    controller.updateListFilter();
                  }
                });
              });
          });
      });
  };

  $scope.undelete = function(item) {
    callOperationService(item, 'undo_delete').then(function(result) {
      item.isProcessed = false;
      item.isDeleted = false;
    });
  };

  $scope.undoBook = function(item) {
    callOperationService(item, 'undo_book').then(function(result) {
      item.isProcessed = false;
      item.isBooked = false;

      controller.data = controller.data.filter(function(val) {
        return val.id !== result.updatedElement.id;
      });

      controller.updateListFilter();
    });
  };

  init();

  return controller;
}
